import { getUrlStatic } from './placeholders-football';

export type PlaceholderMotorsportsType = 'TournamentFlag';

export const TOURNAMENTFLAG: PlaceholderMotorsportsType = 'TournamentFlag';

export const placeholdersMap: {
  [key in PlaceholderMotorsportsType]: string;
} = {
  [TOURNAMENTFLAG]: `https://${getUrlStatic()}/images/skysport/configurations/placeholders/motorsports/driver-flag.png`,
};
